import { Inject, Injectable } from '@angular/core';
import {
  IStoreService,
  OrderModel,
  StorePageStore,
  STORE_SERVICE,
} from '@boxx/store-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import * as fromOrdersActions from './store-orders.actions';

@Injectable()
export class StoreOrdersEffects {
  loadOrders$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromOrdersActions.loadOrdersBeginAction),
      switchMap(() =>
        this.service.loadOrders().pipe(
          mergeMap((data) => [
            fromOrdersActions.loadOrdersSuccessAction({ payload: data }),
            fromOrdersActions.clearOrdersSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadOrders$ ERROR', errors);
            return of([
              fromOrdersActions.loadOrdersFailAction({ errors }),
              fromOrdersActions.clearOrdersSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  loadOrderById$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromOrdersActions.loadOrderByIdBeginAction),
      switchMap((action: any) =>
        this.service.loadOrderById(action.id).pipe(
          mergeMap((payload) => [
            fromOrdersActions.loadOrderByIdSuccessAction({ payload }),
            fromOrdersActions.clearOrdersSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadOrderById$ ERROR', errors);
            return of([
              fromOrdersActions.loadOrderByIdFailAction({ errors }),
              fromOrdersActions.clearOrdersSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  updateOrder$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromOrdersActions.updateOrderBeginAction),
      withLatestFrom(this.storePageStore.ordersStore.data$),
      switchMap(([action, ordersData]: [any, OrderModel[]]) =>
        this.service.updateOrder(action.payload).pipe(
          mergeMap((data) => {

            const orderFilter = ordersData.filter((c) => c.id === action.payload.id);
            const newOrderStatus = Object.assign({}, orderFilter[0]);
            newOrderStatus.paymentStatus = action.payload.paymentStatus;
            newOrderStatus.fulfillmentStatus = action.payload.fulfillmentStatus;
            const payload = newOrderStatus;
            return [
              fromOrdersActions.updateOrderSuccessAction({ payload }),
              fromOrdersActions.clearOrdersSuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.updateOrderById$ ERROR', errors);
            return of([
              fromOrdersActions.updateOrderFailAction({ errors }),
              fromOrdersActions.clearOrdersSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  constructor(
    private actions: Actions,
    private storePageStore: StorePageStore,
    @Inject(STORE_SERVICE) private service: IStoreService
  ) {}
}
